import IconButton from '@mui/material/IconButton'
import styled from '@mui/material/styles/styled'

export const IconButtonStyled = styled(IconButton, {
  name: 'IconButtonStyled',
})`
  background: rgba(0, 0, 0, 0.04);
  &:hover {
    background: #e4e6ea;
  }
  width: 46px;
  height: 46px;
`
